export const testNodeHealth = async (node: string): Promise<boolean> => {
  let alive = false;
  const result = await fetch(node);
  // console.log('callback', result);
  if (result.status === 200) {
    alive = true;
  }

  return alive;
};
